import { useEffect, useRef, useState } from "react";
import { useOverLimitTrigger } from "@/pages/dashboard/components/OverLimitTip";
import { getLocale, shallowEqual, useSelector } from "umi";
import moment from "moment";
import { downLoadPcConsoleV3DayPerformanceTable, getPcConsoleV3DayPerformanceTable } from "@/pages/dashboard/services/overview";
import { LANGUAGE_MAP, PERIODTIMEOBJ } from "@/pages/dashboard/_config/constant";
import { IsSingleDay } from "@/pages/dashboard/utils/utils";
import { PagingQuery } from "tea-component";
import { getTableRequestParams } from "./hooks";
import { ComponentMetricsItemType } from "@/pages/dashboard/components/PageContainer/type";
import { SortBy } from "tea-component/lib/table/addons";
import { overallPlaytimeFormatter } from "./utils";

const useData = (
  filterValue: any,
  filterLoading: boolean,
  selectType: string,
  config: {
    api: any,
    formatType: string
    formatData?: Function,
    isHaveDiff?: boolean,
    componentMetrics: ComponentMetricsItemType,
  },
  otherParams?: any
  // getRequestParams: Function,
) => {
  const { api: apiObj, componentMetrics, formatData, isHaveDiff = false, formatType } = config || {}
  // 加载状态
  const [loading, setLoading] = useState<boolean>(true);
  const [isError, setIsError] = useState<boolean>(false);
  // // 分页
  const [paging, setPaging] = useState<PagingQuery>({ pageSize: 10, pageIndex: 1 });
  // // 排序
  const [sort, setSort] = useState<SortBy[]>([])
  // 总条数
  const [total, setTotal] = useState(0)
  const [frontLogicalFlag, setFrontLogicalFlag] = useState<string | undefined>(undefined)
  const { overLimitBarTriggerKey, handleResponse } = useOverLimitTrigger()

  // 表格数据
  const [tableData, setTableData] = useState([])

  // 聚合数据
  const [statisticsData, setStatisticsData] = useState([])

  // const [,forceUpdate] = useReducer(x=>x+1,0)
  const filterValueSort = useRef(filterValue);
  const accumulateOldValueRef = useRef(['date'])

  const gameCode = useSelector((state: any) => state?.dashboard?.currentGame?.game_code, shallowEqual)

  const metricsList = componentMetrics?.map((item: { reqMetricKey: any; }) => item?.reqMetricKey) || [];

  // 获取表格上传参数
  const getRequestParams = (paging: any, sort: any, filterValue: any, otherParams?: any) => {

    let {  diff, timeType,singleDaily } = filterValue || {};


    return getTableRequestParams({
      gameCode, filterValue,
      accumulated: accumulateOldValueRef?.current,
      sort: sort,
      paging: paging,
      selectType,
      singleDaily:singleDaily,
      metrics: metricsList || [],
      ...otherParams,
    })
  }

  useEffect(() => {
    filterValueSort.current = { filterValue, paging }
  }, [filterValue, paging, sort])

  // 点击筛选器的时候
  useEffect(() => {
    if (filterLoading) return;
    setPaging({ pageIndex: 1, pageSize: paging.pageSize });
    setSort([])
    const params = getRequestParams({ pageIndex: 1, pageSize: paging.pageSize }, [], filterValue, otherParams)
    getTableData(params);

  }, [filterValue, filterLoading])

  const formatDataMap: any = {
    'playtime': overallPlaytimeFormatter
  }

  const getTableData = (params: any) => {
    setIsError(false);
    setLoading(true);
    const api = `${apiObj?.tableApi}?language=${LANGUAGE_MAP[getLocale()]}`
    getPcConsoleV3DayPerformanceTable(api, params).then((res) => {
      setLoading(false);
      const data = formatDataMap?.[formatType] ? formatDataMap?.[formatType](params, res) : formatData ? formatData(params, res) : res
      setTableData(data?.metrics_list || [])
      setStatisticsData(data?.aggregation || [])
      // 设置总条数
      setTotal(res.row_count)
      setFrontLogicalFlag(res?.front_logical_flag)
      handleResponse(res?.front_logical_flag)
    }).catch(e => {
      setLoading(false)
      setIsError(true);
      console.log("宽表请求错误: ", filterValue.timeType, e);
    })
  }


  return {
    tableData,
    statisticsData,
    paging,
    loading,
    isError,
    sort,
    total,
    frontLogicalFlag,
    overLimitBarTriggerKey,
    filterValueSort,
    accumulateOldValueRef,
    isSingle: IsSingleDay({ ...filterValue, period: PERIODTIMEOBJ[filterValue?.timeType] }),
    setPaging,
    setSort,
    getRequestParams,
    getData: getTableData,
    downLoadData: downLoadPcConsoleV3DayPerformanceTable
  }
}

export default useData;